import styled from 'styled-components';

export const PatternedStrip = styled.div<{ backgroundUrl: any }>`
  background-image: URL(${({ backgroundUrl }) => backgroundUrl});
  background-repeat: repeat-x;
  height: 56px;
  width: 100%;
`;
